import type { OpenClawApp } from "./app.ts";
import { parseSessionKeyPath } from "./chat/session-key-path.ts";
import { buildLogsTailRequestFilters } from "./controllers/logs-filters.ts";
import { loadLogs } from "./controllers/logs.ts";

export async function reloadLogs(
  app: OpenClawApp,
  opts?: { reset?: boolean; quiet?: boolean },
): Promise<void> {
  const filters = buildLogsTailRequestFilters(app.settings, app);
  await loadLogs(app, { ...opts, filters });
}

export function onFleetSessionChangeForLogs(app: OpenClawApp): void {
  if (app.tab !== "logs" || !app.settings.logsScopeLinked) {
    return;
  }
  app.logsCursor = null;
  void reloadLogs(app, { reset: true });
}

export function applyLogsScopeLinked(app: OpenClawApp, linked: boolean): void {
  app.applySettings({
    ...app.settings,
    logsScopeLinked: linked,
    ...(linked ? { logsScopePath: parseSessionKeyPath(app.settings.sessionKey) } : {}),
  });
  app.logsCursor = null;
  void reloadLogs(app, { reset: true });
}

export function applyLogsScopePath(
  app: OpenClawApp,
  path: import("./chat/session-key-path.ts").SessionKeyPath,
): void {
  app.applySettings({
    ...app.settings,
    logsScopeLinked: false,
    logsScopePath: path,
  });
  app.logsCursor = null;
  void reloadLogs(app, { reset: true });
}

export function applyLogsViewAll(app: OpenClawApp, viewAll: boolean): void {
  app.applySettings({
    ...app.settings,
    logsViewAll: viewAll,
    ...(viewAll ? { logsScopeLinked: false } : {}),
  });
  app.logsCursor = null;
  void reloadLogs(app, { reset: true });
}
